// Story 1.22 — SPA private page for the post-approval creator profile.
//
// Status-driven render via GET /api/v1/creators/me:
//   * 200                                  → edit form (CreatorProfileForm)
//   * 403 CREATOR_PROFILE_FORBIDDEN
//       reason=not_approved                → NotApprovedCard
//       reason=suspended                   → SuspendedCard
//   * any other error                      → fallback error message

import { CreatorProfileForm } from "../features/creator-profile/CreatorProfileForm";
import { NotApprovedCard } from "../features/creator-profile/NotApprovedCard";
import { SuspendedCard } from "../features/creator-profile/SuspendedCard";
import { useCreatorProfile } from "../features/creator-profile/useCreatorProfile";

export function CreatorProfilePage() {
  const { data, isLoading, error } = useCreatorProfile();

  let content;
  if (isLoading) {
    content = <p className="opacity-70">Loading…</p>;
  } else if (error) {
    if (error.code === "CREATOR_PROFILE_FORBIDDEN") {
      if (error.reason === "suspended") {
        content = <SuspendedCard />;
      } else {
        content = <NotApprovedCard />;
      }
    } else {
      content = (
        <p className="text-destructive">
          Couldn't load your profile. Try refreshing.
        </p>
      );
    }
  } else if (data?.data) {
    content = <CreatorProfileForm profile={data.data} />;
  }

  return (
    <main className="min-h-screen bg-brand-paper-200 text-brand-forest-900">
      <div className="max-w-6xl mx-auto px-6 py-10">
        <header className="mb-8">
          <h1 className="text-3xl md:text-4xl font-heading font-bold mb-2">
            Your creator profile
          </h1>
          <p className="opacity-80">
            Edit how you appear on Greenhold. The live certificate preview
            reflects how future share certificates of you will look — existing
            shares stay exactly as they were when minted.
          </p>
        </header>
        {content}
      </div>
    </main>
  );
}
